<main class="page-body">
  <mat-card appearance="outlined" class="content-center server-error">
    <h2>We're sorry, something has gone wrong.</h2>
    <h2>
      We are working on a solution as quickly as possible so please check back
      soon.
    </h2>
    <img src="/assets/server-error.svg" width="408px" />
    <button
      mat-flat-button
      color="accent"
      class="create-button"
      [routerLink]="'/login'"
    >
      Back to Login
    </button>
  </mat-card>
</main>
